import { render } from "./ProjectPublicationsCreateFormTypeSelector.vue?vue&type=template&id=06430946&scoped=true"
import script from "./ProjectPublicationsCreateFormTypeSelector.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationsCreateFormTypeSelector.vue?vue&type=script&lang=js"

import "./ProjectPublicationsCreateFormTypeSelector.vue?vue&type=style&index=0&id=06430946&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06430946"]])

export default __exports__